import { Headset, RotateCcw, Shield, Truck } from "lucide-react";
import React from "react";

const Features = () => {
  return (
    <section class="max-w-7xl mx-auto px-4 py-4 my-16">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        <div class="text-center p-6 rounded-lg bg-card border hover:border-[#82b016] shadow-sm text-gray-700 transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-lg">
          <div class="w-12 h-12 flex items-center justify-center mx-auto mb-4">
            <Truck className="w-24 h-24" />
          </div>
          <h3 class="font-semibold mb-2 text-xl">Free Shipping</h3>
          <p class="text-sm">On orders over $99</p>
        </div>
        <div class="text-center p-6 rounded-lg bg-card border hover:border-[#82b016] shadow-sm text-gray-700 transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-lg">
          <div class="w-12 h-12 flex items-center justify-center mx-auto mb-4">
            <Shield className="w-24 h-24" />
          </div>
          <h3 class="font-semibold mb-2 text-xl">Secure Payment</h3>
          <p class="text-muted-foreground text-sm">100% secure checkout</p>
        </div>
        <div class="text-center p-6 rounded-lg bg-card border hover:border-[#82b016] shadow-sm text-gray-700 transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-lg">
          <div class="w-12 h-12 flex items-center justify-center mx-auto mb-4">
            <RotateCcw className="w-24 h-24" />
          </div>
          <h3 class="font-semibold mb-2 text-xl">Easy Returns</h3>
          <p class="text-muted-foreground text-sm">30-day return policy</p>
        </div>
        <div class="text-center p-6 rounded-lg bg-card border hover:border-[#82b016] shadow-sm text-gray-700 transition-all duration-300 transform hover:-translate-y-0.5 hover:shadow-lg">
          <div class="w-12 h-12 flex items-center justify-center mx-auto mb-4">
            <Headset className="w-24 h-24" />
          </div>
          <h3 class="font-semibold mb-2 text-xl">24/7 Support</h3>
          <p class="text-muted-foreground text-sm">
            Dedicated customer service
          </p>
        </div>
      </div>
    </section>
  );
};

export default Features;
